<template>
  <div>
    <div class="card p-4 shadow-sm">
      <h3 class="mb-3">Empaque de Platillos</h3>

      <!-- Buscador de platillos -->
      <div class="row mb-4">
        <div class="col-md-8">
          <input
            type="text"
            class="form-control"
            placeholder="Buscar platillo..."
            v-model="buscadorPlatillos"
            @input="buscarPlatillos"
          />
        </div>
      </div>

      <!-- Resultados del buscador -->
      <ul v-if="resultadosPlatillos.length > 0" class="list-group">
        <li
          v-for="platillo in resultadosPlatillos"
          :key="platillo.IdPlatillo"
          class="list-group-item list-group-item-action"
          @click="seleccionarPlatillo(platillo)"
        >
          {{ platillo.Nombre }}
        </li>
      </ul>

      <!-- Seleccionar platillo -->
      <div class="row mb-4">
        <div class="col-md-8">
          <select v-model.number="platilloSeleccionado" class="form-select" @change="cargarEmpaque">
            <option disabled value="">-- Selecciona un platillo --</option>
            <option v-for="p in platillos" :key="p.IdPlatillo" :value="p.IdPlatillo">
              {{ p.Nombre }}
            </option>
          </select>
        </div>
      </div>

      <div v-if="!platilloSeleccionado" class="alert alert-secondary">
        Selecciona un platillo para administrar su empaque
      </div>

      <!-- Lista de empaque -->
      <div v-if="platilloSeleccionado">
        <h5 class="mb-3">Empaque asignado</h5>

        <table class="table table-bordered text-center align-middle">
          <thead class="table-light">
            <tr>
              <th>Producto</th>
              <th>Cantidad</th>
              <th>Acciones</th>
            </tr>
          </thead>

          <tbody>
            <tr v-if="empaque.length === 0">
              <td colspan="3">No hay insumos de empaque registrados.</td>
            </tr>

            <tr v-for="item in empaque" :key="item.IdEmpaquePlatillo">
              <td>{{ item.producto?.NombreProducto }}</td>
              <td>{{ item.Cantidad }}</td>

              <td>
                <button class="btn btn-primary btn-sm me-2" @click="abrirModalEditar(item)">
                  Editar
                </button>
                <button class="btn btn-danger btn-sm" @click="eliminarItem(item.IdEmpaquePlatillo)">
                  Eliminar
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="text-end mt-3">
          <button class="btn btn-success" @click="mostrarModalNuevo = true">
            + Agregar Insumo
          </button>

        </div>
      </div>
    </div>

    <!-- Modal Nuevo -->
    <div v-if="mostrarModalNuevo" class="modal-backdrop">
      <div class="modal-content">
        <h5>Agregar Insumo de Empaque</h5>

        <div class="row g-3 mt-3">

          <!-- Buscador dinámico -->
          <div class="col-md-8 position-relative">
            <label class="form-label">Producto</label>
            <input
              type="text"
              class="form-control"
              placeholder="Buscar producto..."
              v-model="buscador"
              @input="buscarProductoDebounce"
            />

            <!-- Resultados -->
            <ul
              v-if="resultados.length > 0"
              class="list-group position-absolute w-100"
              style="z-index: 5002; max-height: 180px; overflow-y: auto; cursor: pointer;"
            >
              <li
                v-for="prod in resultados"
                :key="prod.IdProductoRestaurante"
                class="list-group-item list-group-item-action"
                @click="seleccionarProductoNuevo(prod)"
              >
                {{ prod.NombreProducto }} (Stock: {{ prod.StockActual }})
              </li>
            </ul>
          </div>

          <div class="col-md-4">
            <label class="form-label">Cantidad</label>
            <input
              v-model.number="nuevoItem.Cantidad"
              type="number"
              min="1"
              step="1"
              class="form-control"
            />
          </div>
        </div>

        <div class="text-end mt-3">
          <button class="btn btn-secondary me-2" @click="cerrarModalNuevo">Cancelar</button>
          <button class="btn btn-primary" @click="guardarNuevo">Guardar</button>
        </div>
      </div>
    </div>

    <!-- Modal Editar -->
    <div v-if="mostrarModalEditar" class="modal-backdrop">
      <div class="modal-content">
        <h5>Editar Insumo de Empaque</h5>

        <div class="row g-3 mt-3">
          <!-- Buscador dinámico para editar -->
          <div class="col-md-8 position-relative">
            <label class="form-label">Producto</label>
            <input
              type="text"
              class="form-control"
              placeholder="Buscar producto..."
              v-model="buscadorEditar"
              @input="buscarProductoEditarDebounce"
            />

            <!-- Resultados editar -->
            <ul
              v-if="resultadosEditar.length > 0"
              class="list-group position-absolute w-100"
              style="z-index: 5002; max-height: 180px; overflow-y: auto; cursor: pointer;"
            >
              <li
                v-for="prod in resultadosEditar"
                :key="prod.IdProductoRestaurante"
                class="list-group-item list-group-item-action"
                @click="seleccionarProductoEditar(prod)"
              >
                {{ prod.NombreProducto }} (Stock: {{ prod.StockActual }})
              </li>
            </ul>
          </div>

          <div class="col-md-4">
            <label class="form-label">Cantidad</label>
            <input
              v-model.number="editarItem.Cantidad"
              type="number"
              min="1"
              step="1"
              class="form-control"
            />
          </div>
        </div>

        <div class="text-end mt-3">
          <button class="btn btn-secondary me-2" @click="cerrarModalEditar">Cancelar</button>
          <button class="btn btn-primary" @click="actualizarItem">Actualizar</button>
        </div>
      </div>
    </div>

    <!-- Toast -->
    <div
      v-if="mostrarToast"
      class="toast-container position-fixed top-0 end-0 p-3"
      style="z-index: 1055"
    >
      <div class="toast show align-items-center text-white" :class="toastColor">
        <div class="d-flex">
          <div class="toast-body">
            <i :class="iconoToast" class="me-2"></i>
            {{ mensajeToast }}
          </div>
          <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="cerrarToast"></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/config/config.js";

export default {
  name: "EmpaquePlatillos",
  data() {
    return {
      platillos: [],
      empaque: [],
      platilloSeleccionado: "",

      // NUEVO: buscadores
      buscador: "",
      resultados: [],
      buscadorEditar: "",
      resultadosEditar: [],
      timer: null,
      timer2: null,

      // Buscador de platillos
      buscadorPlatillos: "",
      resultadosPlatillos: [],

      mostrarModalNuevo: false,
      mostrarModalEditar: false,

      nuevoItem: { IdProductoRestaurante: "", Cantidad: 1 },
      editarItem: null,

      mostrarToast: false,
      mensajeToast: "",
      tipoToast: "success",
    };
  },

  computed: {
    toastColor() {
      return this.tipoToast === "success" ? "bg-success" : "bg-danger";
    },
    iconoToast() {
      return this.tipoToast === "success"
        ? "bi bi-check-circle"
        : "bi bi-exclamation-circle";
    },
  },

  methods: {
    mostrarToastMsg(msg, tipo = "success") {
      this.mensajeToast = msg;
      this.tipoToast = tipo;
      this.mostrarToast = true;
      setTimeout(() => (this.mostrarToast = false), 3000);
    },

    async cargarPlatillos() {
      const { data } = await axios.get(`${API_URL}/platillos`);
      this.platillos = data.data || data;
    },

    async cargarEmpaque() {
      const { data } = await axios.get(
        `${API_URL}/empaque-platillo/${this.platilloSeleccionado}`
      );
      this.empaque = data.empaque;
    },

    // =============== BUSCADOR NUEVO ===============
    buscarProductoDebounce() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.buscarProducto(), 300);
    },

    async buscarProducto() {
      if (this.buscador.length < 2) {
        this.resultados = [];
        return;
      }

      const { data } = await axios.get(`${API_URL}/buscar-productos-empaque`, {
        params: { q: this.buscador },
      });

      this.resultados = data;
    },

    seleccionarProductoNuevo(prod) {
      this.nuevoItem.IdProductoRestaurante = prod.IdProductoRestaurante;
      this.buscador = prod.NombreProducto;
      this.resultados = [];
    },

    // =========== BUSCADOR EDITAR ============
    buscarProductoEditarDebounce() {
      clearTimeout(this.timer2);
      this.timer2 = setTimeout(() => this.buscarProductoEditar(), 300);
    },

    async buscarProductoEditar() {
      if (this.buscadorEditar.length < 2) {
        this.resultadosEditar = [];
        return;
      }

      const { data } = await axios.get(`${API_URL}/buscar-productos-empaque`, {
        params: { q: this.buscadorEditar },
      });

      this.resultadosEditar = data;
    },

    seleccionarProductoEditar(prod) {
      this.editarItem.IdProductoRestaurante = prod.IdProductoRestaurante;
      this.buscadorEditar = prod.NombreProducto;
      this.resultadosEditar = [];
    },

    // ========== BUSCADOR PLATILLOS ==========
    buscarPlatillos() {
      const query = this.buscadorPlatillos.toLowerCase();
      this.resultadosPlatillos = this.platillos.filter((platillo) =>
        platillo.Nombre.toLowerCase().includes(query)
      );
    },

    seleccionarPlatillo(platillo) {
      this.platilloSeleccionado = platillo.IdPlatillo;
      this.buscadorPlatillos = ""; // Clear the search input
      this.resultadosPlatillos = [];
      this.cargarEmpaque();
    },

    // ========== CRUD ==========
    cerrarModalNuevo() {
      this.mostrarModalNuevo = false;
      this.nuevoItem = { IdProductoRestaurante: "", Cantidad: 1 };
      this.buscador = "";
      this.resultados = [];
    },

    cerrarModalEditar() {
      this.mostrarModalEditar = false;
      this.editarItem = null;
      this.buscadorEditar = "";
      this.resultadosEditar = [];
    },

    abrirModalEditar(item) {
      this.editarItem = JSON.parse(JSON.stringify(item));
      this.buscadorEditar = item.producto?.NombreProducto || "";
      this.mostrarModalEditar = true;
    },

    async guardarNuevo() {
      try {
        await axios.post(`${API_URL}/empaque-platillos`, {
          IdPlatillo: this.platilloSeleccionado,
          items: [this.nuevoItem],
        });

        this.mostrarToastMsg("Empaque agregado con éxito");
        this.cerrarModalNuevo();
        this.cargarEmpaque();
      } catch (err) {
        this.mostrarToastMsg("Error al agregar empaque", "danger");
      }
    },

    async actualizarItem() {
      try {
        await axios.put(
          `${API_URL}/empaque-platillos/${this.editarItem.IdEmpaquePlatillo}`,
          this.editarItem
        );

        this.mostrarToastMsg("Empaque actualizado");
        this.cerrarModalEditar();
        this.cargarEmpaque();
      } catch (err) {
        this.mostrarToastMsg("Error al actualizar", "danger");
      }
    },

    async eliminarItem(id) {
      if (!confirm("¿Eliminar este insumo de empaque?")) return;

      await axios.delete(`${API_URL}/empaque-platillos/${id}`);
      this.mostrarToastMsg("Eliminado correctamente");
      this.cargarEmpaque();
    },
  },

  mounted() {
    this.cargarPlatillos();
  },
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5000;
}

.modal-content {
  background: #fff;
  width: 550px;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  z-index: 5001;
}
</style>
